import {FormikHelpers} from 'formik';
import {RouteComponentProps} from 'react-router-dom';
import lQs from 'qs';
import Base64 from 'base-64';
import {notify} from '@gemcook/notification';

import paths from '@paths';
import utils from '@utils';
import api from '@api';
import constants from '@constants';

export const confirmCode = async (
  value: any,
  formikAction: FormikHelpers<any>,
  props: RouteComponentProps
) => {
  try {
    formikAction.setSubmitting(true);

    const windowQs = window.location.search;
    const strQs = windowQs.slice(1);
    const parsedQs = lQs.parse(strQs);
    const username = Base64.decode(parsedQs.username);
    const sub = Base64.decode(parsedQs.sub);

    // 1. Cognitoユーザーをアクティベート
    await utils.amplify.confirmSignUp(username, value.code);

    // 2. DBのユーザーをアクティベート
    const b: UserActivateBody = {
      sub,
    };

    await api.users.activate(b);
    notify('ユーザーの認証に成功しました。ログインして下さい。', 'success');

    props.history.push(paths.signIn.main);
  } catch (error) {
    switch (error.message) {
      case 'Invalid verification code provided, please try again.': {
        notify(constants.ERRORS.FAILD_CODE, 'error');
        break;
      }
      case 'User cannot be confirmed. Current status is CONFIRMED': {
        notify(constants.ERRORS.EXISTED_CONFIRM_CODE, 'error');
        break;
      }
      default: {
        notify(constants.ERRORS.FAILD_CONFIRMED, 'error');
      }
    }
  } finally {
    formikAction.setSubmitting(false);
  }
};
